// Generated by CoffeeScript 1.12.7
(function () {
  module.exports = function (account, user, environment) {
    if (environment !== "production") {
      console.debug("Account: ", account);
      return console.debug("User: ", user);
    }
  };
}.call(this));
